import { useTranslation } from "react-i18next";
import { useSetResponsiblePersonMutation, type PersonDto } from "../../autogen/bff-api";
import { ChangeResponsibleButton } from "../../common/persons/ChangeResponsibleButton";

export const ChangeResponsiblePersonButton = ({
  eventId,
  canManage,
  ownerOrgId,
  homeDepartmentId,
  currentResponsible,
  variant = "link",
}: {
  eventId: string;
  canManage: boolean;
  ownerOrgId: string;
  homeDepartmentId?: string | null;
  currentResponsible: PersonDto;
  variant?: "link" | "outline";
}) => {
  const { t } = useTranslation();
  const [setResponsible, { isLoading }] = useSetResponsiblePersonMutation();

  if (!canManage) return null;

  return (
    <ChangeResponsibleButton
      ownerOrgId={ownerOrgId}
      departmentId={homeDepartmentId}
      currentResponsible={currentResponsible}
      explanation={t("Select a new responsible buyer. Only users who can create events are shown.")}
      save={async (personId) => {
        await setResponsible({ eventId, setResponsiblePersonRequest: { responsiblePersonId: personId } }).unwrap();
      }}
      isSaving={isLoading}
      variant={variant}
    />
  );
};
